import React from "react";
import { useNavigate } from "react-router-dom";
import AppLayoutDoctor from "../../../navigation/Layout/LayoutDoctor";
import ShareCaseChoice from "../../components/ShareCaseChoice/ShareCaseChoice";
import { CASE_DISCUSSIONS_ROUTES } from "../../routePaths";

export default function CreateCase() {
  const navigate = useNavigate();

  return (
    <AppLayoutDoctor>
      <div className="mcd-create-case-page">
        <ShareCaseChoice
          onBack={() => navigate(CASE_DISCUSSIONS_ROUTES.LIST)}
          onStandardCase={() =>
            navigate(CASE_DISCUSSIONS_ROUTES.LIST, {
              state: { openCreate: true },
            })
          }
          onGoLive={() =>
            navigate(CASE_DISCUSSIONS_ROUTES.LIST, {
              state: { openGoLive: true },
            })
          }
        />
      </div>
    </AppLayoutDoctor>
  );
}
